import React, { useEffect, createElement, Component } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // 1. INJECT META PIXEL & FIRE EVENTS (PageView + ViewContent)
    const script = document.createElement('script');
    script.id = 'meta-pixel-script';
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      
      fbq('init', '26904114352525543');
      fbq('track', 'PageView');
      
      // ViewContent Event
      fbq('track', 'ViewContent', {
        content_name: 'The Lucky Flush Protocol',
        content_category: 'Digital Product / Spirituality',
        value: 27.00,
        currency: 'USD'
      });
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.id = 'meta-pixel-noscript';
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=26904114352525543&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
    // 2. UTM & SRC PARAMETER CAPTURE & PERSISTENCE
    const captureAndPersistParams = () => {
      const paramsToCapture = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'src'];
      const urlParams = new URLSearchParams(window.location.search);
      let storedParams: Record<string, string> = {};
      try {
        storedParams = JSON.parse(sessionStorage.getItem('captured_params') || '{}');
      } catch (e) {
        storedParams = {};
      }
      let paramsUpdated = false;
      paramsToCapture.forEach(param => {
        if (urlParams.has(param)) {
          storedParams[param] = urlParams.get(param) as string;
          paramsUpdated = true;
        }
      });
      if (paramsUpdated) {
        sessionStorage.setItem('captured_params', JSON.stringify(storedParams));
      }
      return storedParams;
    };
    const storedParams = captureAndPersistParams();
    // 3. AUTOMATIC URL APPENDING (PASS-THROUGH)
    const appendParamsToLinks = () => {
      const paramKeys = Object.keys(storedParams);
      if (paramKeys.length === 0) return;
      const queryString = paramKeys.map(key => `${encodeURIComponent(key)}=${encodeURIComponent(storedParams[key])}`).join('&');
      // Find all CTA links (matching our placeholder #checkout or real hotmart links)
      const links = document.querySelectorAll('a[href*="#checkout"], a[href*="hotmart.com"]');
      links.forEach(link => {
        let href = link.getAttribute('href');
        // Prevent appending multiple times
        if (href && !href.includes(paramKeys[0] + '=')) {
          const separator = href.includes('?') ? '&' : '?';
          link.setAttribute('href', href + separator + queryString);
        }
      });
    };
    // Run initially
    appendParamsToLinks();
    // Use MutationObserver to ensure links rendered slightly later by React are also caught
    const observer = new MutationObserver(() => {
      appendParamsToLinks();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    // Cleanup on unmount
    return () => {
      const s = document.getElementById('meta-pixel-script');
      const ns = document.getElementById('meta-pixel-noscript');
      if (s) s.remove();
      if (ns) ns.remove();
      observer.disconnect();
    };
  }, []);
  return null;
}